import { useMemo } from "react";
import { useQuery, UseQueryOptions } from "react-query";
import type { tMomentComplatibleDate } from "@/types";
import moment from "moment";
import { QueryKeys } from "@/network/queryKeys";
import { useSelector } from "react-redux";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import { ScheduleAPI } from "@/api/schedule";

type tRes = { start: string; end: string }[];

export type tArgs = {
  masterId: string;
  date: tMomentComplatibleDate;
  days?: number;
};

export const useMasterFreeSlotsQuery = (
  { date: baseDate, masterId, days = 1 }: tArgs,
  opts?: Omit<UseQueryOptions<tRes, unknown, tRes>, "queryKey" | "queryFn">
) => {
  const timezone: string = useSelector(UserSelectors.getTimezone);
  const date = useMemo(
    () => moment(baseDate).startOf("day").toISOString(),
    [baseDate]
  );
  const query = useQuery(
    [
      QueryKeys.freeSlots,
      {
        masterId,
        days,
        from: date,
        timezone,
      },
    ],
    () =>
      ScheduleAPI.getMasterFreeSlots(masterId, {
        from: date,
        days,
        timezone,
      }).then(({ data }) => data as tRes),
    opts
  );
  return query;
};
